import React, { useEffect, useRef, useState } from 'react';
import { waLink, WaIcon } from '../App';
import Img from './Img';

const HEROES = ['IMG_0345','IMG_0594','IMG_8843','IMG_0405'];

export default function Hero() {
  const [idx, setIdx] = useState(0);
  const timer = useRef(null);

  function setHero(i) {
    setIdx(i);
    clearInterval(timer.current);
    timer.current = setInterval(() => setIdx(prev => (prev + 1) % HEROES.length), 5200);
  }

  useEffect(() => {
    timer.current = setInterval(() => setIdx(prev => (prev + 1) % HEROES.length), 5200);
    return () => clearInterval(timer.current);
  }, []);

  return (
    <section style={{ padding:'46px 0 66px' }}>
      <div style={{ maxWidth:1180, margin:'0 auto', padding:'0 26px', display:'grid', gridTemplateColumns:'1.04fr 1fr', gap:54, alignItems:'center' }} className="kt-hero-grid">
        <div>
          <span style={{ fontFamily:'var(--sans)', fontWeight:700, fontSize:12, letterSpacing:2.6, textTransform:'uppercase', color:'var(--plum)', display:'inline-flex', alignItems:'center', gap:9 }}>
            Handmade · made to order
          </span>
          <h1 style={{ fontSize:'clamp(3rem,6.4vw,5.3rem)', margin:'18px 0 0' }}>
            Every cake tells<br />a <em style={{ fontFamily:'var(--serif)', fontStyle:'italic', color:'var(--plum)' }}>story</em>.
          </h1>
          <p style={{ fontSize:19, color:'var(--ink-2)', maxWidth:'46ch', margin:'22px 0 30px' }}>
            Vintage buttercream cakes, cupcakes and bento sets, iced with whatever you need to say and baked fresh for the day that matters.
          </p>
          <div style={{ display:'flex', gap:14, flexWrap:'wrap' }}>
            <a href={waLink("Hi Kreme Tops! I'd love to order a cake.")} target="_blank" rel="noopener noreferrer"
              style={{ display:'inline-flex', alignItems:'center', gap:9, fontFamily:'var(--sans)', fontWeight:700, fontSize:14.5, padding:'14px 24px', borderRadius:40, background:'var(--plum)', color:'#fff', boxShadow:'var(--shadow-sm)', transition:'transform .15s ease, background .2s', textDecoration:'none' }}
              onMouseOver={e => { e.currentTarget.style.background='var(--plum-deep)'; e.currentTarget.style.transform='translateY(-2px)'; }}
              onMouseOut={e => { e.currentTarget.style.background='var(--plum)'; e.currentTarget.style.transform=''; }}>
              <WaIcon />Order on WhatsApp
            </a>
            <a href="#gallery"
              style={{ display:'inline-flex', alignItems:'center', gap:9, fontFamily:'var(--sans)', fontWeight:700, fontSize:14.5, padding:'14px 24px', borderRadius:40, border:'1.6px solid var(--plum)', background:'transparent', color:'var(--plum-deep)', transition:'transform .15s ease, background .2s', textDecoration:'none' }}
              onMouseOver={e => { e.currentTarget.style.background='rgba(140,100,120,.08)'; e.currentTarget.style.transform='translateY(-2px)'; }}
              onMouseOut={e => { e.currentTarget.style.background='transparent'; e.currentTarget.style.transform=''; }}>
              See the gallery
            </a>
          </div>
          <div style={{ marginTop:26, fontSize:13.5, color:'var(--ink-3)', letterSpacing:.3, display:'flex', alignItems:'center', gap:10, flexWrap:'wrap' }}>
            <strong style={{ color:'var(--plum-deep)', fontWeight:700 }}>Nairobi</strong>
            <span style={{ width:4, height:4, borderRadius:'50%', background:'var(--ink-3)', display:'inline-block' }} />
            48hrs - 72hrs notice
            <span style={{ width:4, height:4, borderRadius:'50%', background:'var(--ink-3)', display:'inline-block' }} />
            pickup or delivery
          </div>
        </div>

        <div style={{ position:'relative' }} className="kt-hero-media">
          <div className="kt-hero-badge" style={{ position:'absolute', left:-20, top:30, zIndex:3, background:'var(--gold)', color:'#fff', fontFamily:'var(--serif)', fontStyle:'italic', fontSize:19, padding:'10px 18px', borderRadius:40, boxShadow:'var(--shadow-sm)', transform:'rotate(-5deg)' }}>
            freshly piped
          </div>
          <div style={{ position:'relative', borderRadius:26, overflow:'hidden', boxShadow:'var(--shadow)', width:'100%', paddingBottom:'125%', background:'var(--blush-deep)' }}>
            {HEROES.map((f, i) => (
              <Img key={f}
                src={`/assets/cakes/${f}.jpeg`}
                alt="Kreme Tops cake"
                loading={i === 0 ? 'eager' : 'lazy'}
                fetchpriority={i === 0 ? 'high' : undefined}
                style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover', opacity: i === idx ? 1 : 0, transition:'opacity .6s ease' }} />
            ))}
            <div style={{ position:'absolute', right:14, top:14, zIndex:2, display:'flex', flexDirection:'column', gap:9 }}>
              {HEROES.map((_, i) => (
                <button key={i} onClick={() => setHero(i)}
                  style={{ width:11, height:11, borderRadius:'50%', border:'1.5px solid #fff', background: i === idx ? '#fff' : 'rgba(255,255,255,.35)', cursor:'pointer', padding:0, boxShadow:'0 1px 5px rgba(0,0,0,.25)', transform: i === idx ? 'scale(1.18)' : '', transition:'background .2s, transform .2s' }} />
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media(max-width:860px){
          .kt-hero-grid{grid-template-columns:1fr!important;gap:34px!important;}
          .kt-hero-media{max-width:440px;margin:0 auto;overflow:visible;}
          .kt-hero-badge{display:none!important;}
        }
      `}</style>
    </section>
  );
}
